/* eslint-disable */
import FullScreenButton from './FullScreenButton';

export default FullScreenButton;
